import { httpEditFormInfo } from '../../Hooks/company/company.post.hooks';

const createNewFormInstance = async ({
  formInfo,
  user,
  provinceId,
  pdfUrl,
  fields,
  data,
}) => {
  const formInstancePayload = {
    formId: formInfo._id,
    companyId: formInfo.companyId,
    provinceId: provinceId || null,
    pdfUrl,
    createdBy: user?.id || user?._id,
    fields,
    data,
    status: 'draft',
  };
  const res = await httpEditFormInfo(formInstancePayload);
  // res is already parsed JSON, not a Response object
  if (res && res.instance && !res.error) {
    return res.instance;
  }
  throw new Error(res?.error || 'Failed to create new form instance');
};

export default createNewFormInstance;
